import loadable from '@loadable/component';

export const GradFairsBannerLoadable = loadable(
  () => import('./GradFairsBanner'),
  { resolveComponent: (module) => module.GradFairsBanner },
);
